import { defineStore } from 'pinia';
import { getPdischarge, getPdischarges, createPdischarges, hasUsedDischarge } from '@/services/modules/pdischarges';

export interface pDischarges {
  id: number;
  discharges: string;
  pos_code: string;
  address: string;
  pic: string;
  tel: string;
  email: string;
}

export const usePDischargesStore = defineStore('pdischarges', {
  state() {
    return {
      pdischarge: {} as pDischarges | null,
      pdischarges: [] as pDischarges[]
    };
  },
  persist: {
    paths: ['pdischarge', 'pdischarges']
  },
  getters: {},
  actions: {
    async fetchPDischarge(id?: number) {
      if (!id) {
        this.pdischarge = {
          id: 0,
          discharges: '',
          pos_code: '',
          address: '',
          pic: '',
          tel: '',
          email: ''
        };
      } else {
        const response: any = await getPdischarge(id);
        this.pdischarge = response;
      }
    },
    async fetchPDischarges() {
      const response: any = await getPdischarges();
      this.pdischarges = response;
    },
    async createPdischarges(
      discharges: string,
      posCode: string,
      address: string,
      pic: string,
      tel: string,
      email: string
    ) {
      await createPdischarges({
        discharges,
        posCode,
        address,
        pic,
        tel,
        email
      });
    },
    async hasUsedDischarge(pDischargeId: number) {
      const response:any = await hasUsedDischarge(pDischargeId);
      return response.result; 
    }
    
    
  }
});
